import { Box } from '@mui/material';

import { sendUserPortalEvent } from '@/lib/analytics/unified.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';

import { CTA } from '../_components/CTA.tsx';
import { RulesCard } from '../_components/RulesCard.tsx';
import { Section } from '../_components/Section.tsx';

export const RulesSection = (props: { activeCompetition: CompetitionWithConfig | undefined }) => {
  return (
    <Section
      sx={{
        gap: { xs: '60px', lg: '100px' },
        flexDirection: { md: 'row' },
        alignItems: { md: 'center' },
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: 'grid',
            maxWidth: { md: '480px' },
            marginLeft: { md: 'auto' },
            marginTop: { lg: 4 },
          }}
        >
          <div className="mb-6 typography-v1-h1">
            Lettere{' '}
            <Box
              component="span"
              sx={{
                color: 'primary.main',
              }}
            >
              gjeldfri!
            </Box>
          </div>
          <Box
            component="div"
            sx={{
              mb: { xs: 3, lg: 5 },
            }}
            className="typography-v1-body3"
          >
            Vi mener at det er viktig å sjekke om du kan få lavere rente. Det kan nemlig gjøre det
            lettere for deg å bli gjeldfri - og du kan spare tusenvis av kroner!
          </Box>
          <CTA
            activeCompetition={props.activeCompetition}
            sx={{ margin: { md: 0 } }}
            onClick={() => {
              sendUserPortalEvent('jul25_competition_cta_bottom_clicked');
            }}
          />
        </Box>
      </Box>
      <RulesCard sx={{ flex: 1 }} />
    </Section>
  );
};
